import { useTheme, useMediaQuery } from '@mui/material';

const useResponsiveBreakpoints = () => {
  const theme = useTheme();
  return {
    isXs: useMediaQuery(theme.breakpoints.only('xs')),
    isSm: useMediaQuery(theme.breakpoints.only('sm')),
    isMd: useMediaQuery(theme.breakpoints.only('md')),
    isLg: useMediaQuery(theme.breakpoints.only('lg')),
    isXl: useMediaQuery(theme.breakpoints.up('xl')),
    isXxl: useMediaQuery('(min-width:1920px)')
  };
};

export default useResponsiveBreakpoints;